module.exports = __webpack_public_path__ + "static/media/image1.f03bcc00.jpg";